import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { TimeEntryCategory, TimeEntryCategoryInput } from '../../entities/timeEntryCategory/timeEntryCategory';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';
/**
 * The users service.
 */
@Injectable()
export class TimeTrackingCategoryService {

  constructor(
    private apolloService: ApolloService
  ) {
  }
  
  /**
   * updates an user
   * @param userInput user Input
   * @param callback method
   */
  public updateTimeEntryCategory(timeEntryCategoryInput: TimeEntryCategoryInput, callback: (arg: any) => void): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.UPDATE_TIME_ENTRY_CATEGORY_MUTATION,
      {
        timeEntryCategoryInput: timeEntryCategoryInput,
      },
      callback
    );
  }
  /**
   * creates an user
   * @param userInput user Inout
   * @param callback method
   */
  public createTimeEntryCategory(timeEntryCategoryInput: TimeEntryCategoryInput, callback: any): void {
    this.apolloService.mutateAndExecute(
      fromGraphQl.CREATE_TIME_ENTRY_CATEGORY_MUTATION,
      {
        timeEntryCategoryInput: timeEntryCategoryInput,
      },
      callback
    );
  }

  public getTimeEntryCategories(): Observable<TimeEntryCategory[]> {
    return this.apolloService.query<fromGraphQl.GetTimeEntryCategoriesResponse>(fromGraphQl.GET_TIME_ENTRY_CATEGORIES_QUERY)
      .pipe(
        take(1),
        switchMap( (result) => {
          return of( TimeEntryCategory.createTimeCategoryEntries(result.data.getTimeEntryCategories));
        })
      );
  } 
  

}

